export default __webpack_public_path__ + "static/media/iga-facilitation.b3976ff2.jpg";